import React from "react";

import "./AttentionBox.css";

interface props {
	rowData: any;
	header: string;
	mainClass: string;
	secondaryClass: string;
	page: string;
}

const AttentionBox: React.FC<props> = ({
	rowData,
	header,
	mainClass,
	secondaryClass,
	page,
}) => {
	return (
		<div
			className={mainClass}
			style={page === "devicePage" ? { height: "35vh", margin: "0" } : {}}
		>
			<h4>{header}</h4>
			{mainClass === "attention-box" ? (
				<div className="attention-scroll">
					{[...rowData]
						.sort((a: any, b: any) => {
							return b.filterDate - a.filterDate;
						})
						.map((notification: any, index: any) => (
							<div
								key={`${notification.filterDate}-${notification.date}-${notification.name}${index}`}
								className={secondaryClass}
							>
								<div className="attention-logo">
									<img
										style={{ width: "20px" }}
										alt="logo"
										src="/media/icons/FaPowerOff.png"
									/>
								</div>
								<div>
									<span>{notification.name}</span>
									<span>
										<strong>{notification.desc}</strong>
									</span>
								</div>
							</div>
						))}
				</div>
			) : (
				<div className="attention-scroll">
					{[...rowData]
						.sort((a: any, b: any) => {
							return b.filterDate - a.filterDate;
						})
						.map((notification: any, index: any) => (
							<div
								key={`${notification.filterDate}-${notification.date}-${notification.name}${index}`}
								className={secondaryClass}
							>
								<div className="activity-logo">
									<img
										style={{ width: "20px" }}
										alt="logo"
										src="/media/icons/paperClip.png"
									/>
								</div>
								<div>
									<span>{notification.name}</span>
									<span>
										<strong>{notification.desc}</strong>
									</span>
								</div>
							</div>
						))}
				</div>
			)}
		</div>
	);
};

export default AttentionBox;
